// export const BaseUrl = "http://localhost:26496/";

// export const BaseUrl = "http://172.25.0.34/CustomerPortalAPIsT/";
// export const BaseUrl = "http://172.25.0.34/CustomerPortalAPIs/";
//export const BaseUrl = "http://172.25.0.18/CustomerPortalAPIsOne/"; 

export const protocol = window.location.protocol;
export const BaseUrl = `${protocol}//codapi.mnpcourier.com/CustomerPortalAPI/`;

//CXMP complaint API
// export const cxmp = "http://43.231.61.149/systech_stagging/";
export const cxmp = "https://cxmapi.mulphilog.com.pk/api/";

export const ApiKey = "1CFE6FD1F558C7B412B63A7FA8A2F";
export const GenerateAddressLabelURL = "https://mnpcourier.com/mycodapi/AddressLabel/index?";
export const TrackingSignImageURL = "https://mraabta1.mulphilog.com.pk/SignImage";
export const TrackingCnImageURL = "https://mraabta1.mulphilog.com.pk/CnImage";

// export const setSession = (key, val) => sessionStorage.setItem(key, JSON.stringify(val));
// export const getSession = (key) => sessionStorage.getItem(key) ? JSON.parse(sessionStorage.getItem(key)) : null;

export const setSession = (key, val) => localStorage.setItem(key, JSON.stringify(val));
export const getSession = (key) => localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : null;


//Encrpytion
// export const setSession = (key, val) => sessionStorage.setItem(key, btoa(JSON.stringify(val)));
// export const getSession = (key) => sessionStorage.getItem(key) ? JSON.parse(atob(sessionStorage.getItem(key))) : null;
//Encrpytion

//export const clearSession = () => sessionStorage.clear();
export const clearSession = () => localStorage.clear();

export const valdiatePage = (hyperLink) => {
    return getSession('userInfo') && getSession('menues').flatMap(x => x.subMenus).some(x => x.hyperLink === hyperLink);
}

export const setLocalStorage = (key, val) => localStorage.setItem(key, JSON.stringify(val));
export const getLocalStorage = (key) => localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : null;

export const processInt = (e) => {
    let value = e.target.value;
    let numbers = value.replace(/[^0-9]/g, "");
    e.target.value = numbers;
}

export const processNum = (e) => {
    let value = e.target.value;
    let numbers = value.replace(/[^0-9.]/g, "");
    e.target.value = numbers;
}

export const onlyStr = (e) => {
    let value = e.target.value;
    let numbers = value.replace(/[^A-Za-z ]/g, "");
    e.target.value = numbers;
}

export const processStrForIBAN = (e) => {
    let value = e.target.value;
    value = value.replace(/\s+/g, '');
    let numbers = value.replace(/[^A-Za-z0-9]/g, "");
    e.target.value = numbers;
}

export const processStr = (e) => {
    let value = e.target.value;
    let numbers = value.replace(/[^A-Za-z0-9]/g, "");
    e.target.value = numbers;
}

export const processStrWithSpace = (e) => {
    let value = e.target.value;
    let numbers = value.replace(/[^A-Za-z0-9 ]/g, "");
    e.target.value = numbers;
}

export const processEmail = (e) => {
    let value = e.target.value;
    let numbers = value.replace(/[^A-Za-z0-9@._-]/g, "");
    e.target.value = numbers;
}

export const processPassword = (e) => {
    let value = e.target.value;
    let numbers = value.replace(/[^A-Za-z0-9@+._-]/g, "");
    e.target.value = numbers;
}

export const processStrWithSpaceAndSpecalChars = (e) => {
    let value = e.target.value;
    let numbers = value.replace(/[^A-Za-z0-9 ,#/-]/g, "");
    e.target.value = numbers;
}

export const isRealObject = (obj) => {
    return obj && obj !== "" && obj !== 'null' && obj !== 'undefined';
}

export const processNumAndComma = (e) => {
    let value = e.target.value;
    let numbers = value.replace(/[^\d,]+/g, '');
    e.target.value = numbers;
}

export const validateEmail = (email) => {
    const pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
    if (pattern.test(email)) {
        return false
    }
    return true
}

export const separatedByCommaCount = (value) => (value === "" ? 0 : value.split(',').length)

export const processEmailNotifications = (e) => {
    let value = e.target.value;
    let numbers = value.replace(/[^A-Za-z0-9@.,_-]/g, "");
    e.target.value = numbers;
}

export const Months = {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December'
}

export const truncateString =(str, num) => {
    let slicedstr;

    if(str.length > num){
        slicedstr = str.slice(0,num)
    }else{
        slicedstr = str
    }

    return slicedstr;
}

export const checkPassword = (str) => {
    var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    return re.test(str);
}

export const formatCountNumber = (number) => {
    return new Intl.NumberFormat().format(number)
}

export const formatCountNumber2digit = (number) => {
    return new Intl.NumberFormat({
        minimumFractionDigits: 2, // Ensure two decimal places for paisa
        maximumFractionDigits: 2
    }).format(number)
}

export const toPascalCase = (str) =>  {
  if (!str) return '';
  return str
    .toLowerCase()
    .replace(/(^\w|\s\w)/g, match => match.toUpperCase())
    .replace(/\s+/g, '');
}
